import Accordion from './lib/accordion';


document.addEventListener('DOMContentLoaded', () => new Accordion());